<template>
  <div v-if="loading" class="text-center">
    <px-circular-loading/>
  </div>
  <v-list v-else>
    <template v-for="(produto, index) in cotacao.produtos">
      <v-list-item :key="produto.id">
        <v-list-item-content>
          <v-list-item-title>
            <px-situacao-cotacao-icon :situacao="produto.situacao"/>
            <px-produto-descricao :especificacao="produto.especificacaoProduto"
                                  :produto="produto.produto"/>
            <px-show-fornecedores-homologados-produto :produto="produto.produto" small/>
          </v-list-item-title>
          <v-list-item-subtitle class="ml-5">
            {{ produto.quantidade | number(getCurrencyFormat(produto.produto.casasDecimais)) }}
            {{produto.unidadeMedida.descricao}}
          </v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action>
          <px-resumo-produto-dialog :produto="produto.produto"
                                    :unidade-medida="produto.unidadeMedida"/>
        </v-list-item-action>
        <v-list-item-action>
          <px-detalhes-produto
            :produto="produto"
            show-projeto
            show-obs-externa
            show-obs-interna
            show-finalidade-compra
            show-data-previsao-entrega
            show-centro-custo
            :show-motivo-recusa="isCancelada(produto)">
              <template v-slot:bottom>
                <px-campos-integracao
                  v-if="cadastrosAdicionaisItem(produto) && erpCamposIntegracao"
                  full-width
                  type="cotacao-produtos-view"
                  :form-data="cadastrosAdicionaisItem(produto)"
                  text-class="small-text"/>
              </template>
          </px-detalhes-produto>
        </v-list-item-action>
        <v-list-item-action>
          <px-anexo read-only
                    v-model="produto.arquivos"
                    download-base-path="files/download-comprador"/>
        </v-list-item-action>
        <v-list-item-action>
          <px-cotacao-produto-menu v-if="hasRoleComprador"
                                   :cotacao="cotacao"
                                   :cotacao-produto="produto"
                                   @update="emitUpdate"/>
        </v-list-item-action>
      </v-list-item>
      <v-divider v-if="index !== (cotacao.produtos.length - 1)"
        :key="`v-div${produto.id}`"/>
    </template>
  </v-list>
</template>

<script>
import { mapGetters } from 'vuex';
import { CasaDecimalUtils } from 'px-components';
import { SituacaoCotacao } from 'px-business-components';
import { cadastrosAdicionaisToMap } from '@/utils/campos-integracao-utils';
import CotacaoProdutoMenu from './CotacaoProdutoMenu.vue';

export default {
  props: {
    cotacao: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapGetters('user', ['hasRoleComprador']),
    ...mapGetters('entidade', ['erpCamposIntegracao']),
    getCurrencyFormat() {
      return item => CasaDecimalUtils.getCurrencyFormat(item);
    },
    cadastrosAdicionaisItem() {
      return (item) => {
        if (!item.cadastrosAdicionais || !item.cadastrosAdicionais.length) {
          return null;
        }
        return cadastrosAdicionaisToMap(item.cadastrosAdicionais);
      };
    },
    isCancelada() {
      return produto => SituacaoCotacao.keys.CANCELADA.key === produto.situacao;
    },
  },
  methods: {
    emitUpdate() {
      this.$emit('update');
    },
  },
  components: {
    pxCotacaoProdutoMenu: CotacaoProdutoMenu,
  },
};
</script>
